import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { paymentServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const paymentInstance = axios.create({
  baseURL: paymentServiceUrl,
  headers,
})

paymentInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

paymentInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default paymentInstance
